<template>
  <div id="app">
    <router-view/>
    <login-modal v-if="showLoginModal" />
  </div>
</template>

<script>
import LoginModal from '@/components/LoginModal.vue'

export default {
  name: 'App',

  computed: {
    showLoginModal () {
      return this.$store.getters['auth/isShowingLoginModal']
    }
  },

  components: {
    LoginModal
  }
}
</script>

<style lang="scss" src="@/assets/sass/app.scss"></style>
